import { Draft } from '@reduxjs/toolkit';

import { IInterventionData } from '../../initialState';

function getStatusDateChangedFailure(draft: Draft<IInterventionData>) {
  draft.getStatusDateChanged.config.isLoading = false;
}

export default getStatusDateChangedFailure;
